// extracted by mini-css-extract-plugin
export default {"form_body_top":"recycled_form_body_top__qldwe","form_body_top_group_top":"recycled_form_body_top_group_top__5mKmh","table-container":"recycled_table-container__DZuAO"};